import { render, staticRenderFns } from "./KozHubVideosVideo.vue?vue&type=template&id=0667b66a&"
import script from "./KozHubVideosVideo.vue?vue&type=script&lang=js&"
export * from "./KozHubVideosVideo.vue?vue&type=script&lang=js&"
import style0 from "./KozHubVideosVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports